.title h2 {
  margin: 0;
}
